import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';

const list = (systemSource, merchantId, branchId, conditions) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableTags`),
		{
			branchId,
			...conditions,
		}
	);
};

const create = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableTags`),
		payload
	);
};

const update = (systemSource, merchantId, id, payload) => {
	return Client.put(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableTags/${id}`),
		payload
	);
};

const remove = (systemSource, merchantId, id, branchId, operateBy) => {
	return Client.del(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/tableTags/${id}`),
		{
			branchId,
			operateBy,
		}
	);
};

export default {
	list,
	create,
	update,
	remove,
};
